import React, { useEffect } from 'react';
import Button, { IButtonProps } from '../Button';

export interface IOffcanvasButtonProps extends IButtonProps {
	children?: any;
	target?: string;
}

const OffcanvasButton: React.FC<IOffcanvasButtonProps> = ({
	target = '.offcanvas',
	...props
}) => {
	useEffect(() => {
		import('bootstrap/js/dist/offcanvas');
	},[]);

	return (
		<Button
			{...props}
			data-bs-toggle="offcanvas"
			data-bs-target={target}
			aria-label="Toggle"
		/>
	);
};

export default OffcanvasButton;
